// @flow
import * as ColorNames from '../common/colorNames';
import {makeBaseHex} from '../common/util';

export const PRIMARY = ColorNames.MARINER;
export const SECONDARY = ColorNames.THUNDER;
export const TERTIARY = Object.assign({}, ColorNames.WHITE, {buttonText: PRIMARY.hex}) // Tertiary is always white button blue background
export const BRAND_PRIMARY = ColorNames.MARINER;
export const BRAND_SECONDARY = ColorNames.ATOMIC_TANGERINE;
export const SUCCESS = ColorNames.GREEN_LEAF;
export const INFO = ColorNames.HAVELOCK_BLUE;
export const WARNING = ColorNames.BUTTERCUP;
export const DANGER = ColorNames.MONZA;
export const LIGHT = ColorNames.ATHENS_GRAY;
export const DARK = ColorNames.FJORD;
export const BLACK = ColorNames.BLACK;
export const WHITE = ColorNames.WHITE;
export const CONTRAST = ColorNames.ATHENS_GRAY;
export const TEXT = ColorNames.ALABASTER;
export const TEXT_INVERSE = ColorNames.FJORD;
export const LINK_TEXT = ColorNames.MARINER;
export const SURFACE_LIGHTER = ColorNames.MINE_SHAFT; // WAS FJORED
export const SURFACE = ColorNames.THUNDER; // WAS FJORED
export const SURFACE_INVERSE = ColorNames.WHITE;
export const SURFACE_LIGHTEST = ColorNames.TUNDORA;
export const DARK_SURFACE_LIGHTER = ColorNames.TUNDORA;
export const INPUT_DISABLED = ColorNames.BLACK;
export const BOX_SHADOW = ColorNames.ATHENS_GRAY;
export const BORDER = makeBaseHex(ColorNames.MINE_SHAFT, 'X500'); // Shifts the default for this theme
export const DROPDOWN_SHADOW = ColorNames.THUNDER;
export const LIGHT_GRAY_SURFACE = ColorNames.TUNDORA;

/* -------------- Component Specific Styles -------------- */

// Search / Reports / Entities Page
export const SEARCH_RESULTS = {
  TITLE: ColorNames.MARINER.X200,
};
export const SEARCH_BAR = ColorNames.TUNDORA;
export const SEARCH_BAR_INPUT = ColorNames.MINE_SHAFT;
export const SEARCH_FILTER_BAR = ColorNames.THUNDER;
export const SEARCH_FILTER_BAR_BUTTON = ColorNames.FJORD;

// Main Nav Bar
export const SIDE_NAV_BAR = ColorNames.THUNDER;
export const SIDE_NAV_BAR_HOVER = ColorNames.TUNDORA;

export const SIDE_NAV_DROPRIGHT_MENU_ITEM = {
  BACKGROUND: SURFACE_LIGHTER.hex,
  BACKGROUND_HOVER: SURFACE_LIGHTER.X500,
  TEXT: WHITE.hex,
  TEXT_HOVER: WHITE.hex,
  SHADOW: DROPDOWN_SHADOW.hex,
};

// Settings Page

export const SETTINGS_PAGE_NAVLINK = SIDE_NAV_DROPRIGHT_MENU_ITEM;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/dark/themeColors.js